import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ErrorTypes, LoginFlowInterface, StateTypes } from '@central-products/interface-login-flow';
import { StateType } from '@central-products/interface-session-manager';
import { LoginContainer } from './LoginContainer';
import './index.scss';
export var LoginFlow = /*#__PURE__*/function (_LoginFlowInterface) {
  _inherits(LoginFlow, _LoginFlowInterface);

  var _super = _createSuper(LoginFlow);

  function LoginFlow(config, dependencies) {
    var _this;

    _classCallCheck(this, LoginFlow);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "dependencies", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.NONE);

    _defineProperty(_assertThisInitialized(_this), "onStateChangedCallback", void 0);

    _defineProperty(_assertThisInitialized(_this), "domNode", null);

    _defineProperty(_assertThisInitialized(_this), "isUserLoggedIn", false);

    _this.config = config;
    _this.dependencies = dependencies;
    return _this;
  }

  _createClass(LoginFlow, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _yield$this$dependenc, sessionState;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.dependencies['session-manager'].getState();

              case 2:
                _yield$this$dependenc = _context.sent;
                sessionState = _yield$this$dependenc.state;
                this.isUserLoggedIn = sessionState === StateType.LOGGED_IN;
                this.dependencies['session-manager'].onStateChanged(function (_ref) {
                  var state = _ref.state;
                  _this2.isUserLoggedIn = state === StateType.LOGGED_IN;

                  if (_this2.isUserLoggedIn && _this2.state === StateTypes.FORM_VISIBLE) {
                    _this2.cancel();
                  }
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _window$performance, _window$performance$m;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.state !== StateTypes.NONE)) {
                  _context2.next = 2;
                  break;
                }

                throw {
                  error: ErrorTypes.INVALID_STATE
                };

              case 2:
                if (!this.isUserLoggedIn) {
                  _context2.next = 4;
                  break;
                }

                throw {
                  error: ErrorTypes.USER_ALREADY_LOGGED_IN
                };

              case 4:
                (_window$performance = window.performance) === null || _window$performance === void 0 ? void 0 : (_window$performance$m = _window$performance.mark) === null || _window$performance$m === void 0 ? void 0 : _window$performance$m.call(_window$performance, 'cp:login:start');
                this.render();
                this.changeState(StateTypes.FORM_VISIBLE);
                return _context2.abrupt("return", {});

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state === StateTypes.NONE || this.domNode === null)) {
                  _context3.next = 2;
                  break;
                }

                throw {
                  error: ErrorTypes.INVALID_STATE
                };

              case 2:
                ReactDOM.unmountComponentAtNode(this.domNode);
                document.body.removeChild(this.domNode);
                this.domNode = null;
                this.changeState(StateTypes.NONE);
                return _context3.abrupt("return", {});

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cancel() {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
  }, {
    key: "getState",
    value: function () {
      var _getState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", {
                  state: this.state
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getState() {
        return _getState.apply(this, arguments);
      }

      return getState;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.onStateChangedCallback = callback;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      this.domNode = document.createElement('div');
      document.body.appendChild(this.domNode);

      var onClose = function onClose() {
        _this3.cancel();
      };

      var onSubmit = function onSubmit() {
        var _window$performance2, _window$performance2$;

        (_window$performance2 = window.performance) === null || _window$performance2 === void 0 ? void 0 : (_window$performance2$ = _window$performance2.mark) === null || _window$performance2$ === void 0 ? void 0 : _window$performance2$.call(_window$performance2, 'cp:login:submit-start');

        _this3.changeState(StateTypes.AWAIT_LOGIN);
      };

      var onSubmitFailed = function onSubmitFailed() {
        var _window$performance3, _window$performance3$;

        (_window$performance3 = window.performance) === null || _window$performance3 === void 0 ? void 0 : (_window$performance3$ = _window$performance3.mark) === null || _window$performance3$ === void 0 ? void 0 : _window$performance3$.call(_window$performance3, 'cp:login:submit-finish');

        _this3.changeState(StateTypes.FORM_VISIBLE);
      };

      var onSubmitSuccess = function onSubmitSuccess() {
        var _window$performance4, _window$performance4$;

        (_window$performance4 = window.performance) === null || _window$performance4 === void 0 ? void 0 : (_window$performance4$ = _window$performance4.mark) === null || _window$performance4$ === void 0 ? void 0 : _window$performance4$.call(_window$performance4, 'cp:login:submit-finish');

        _this3.cancel();
      };

      var onActionRequested = function onActionRequested(eventId, context) {
        var isCloseRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _this3.dependencies['account-actions'].execute({
          eventId: eventId,
          context: _Object$assign({}, context, {
            userFlow: 'login'
          })
        });

        if (isCloseRequired) {
          _this3.cancel();
        }
      };

      ReactDOM.render( /*#__PURE__*/React.createElement(LoginContainer, {
        environment: this.config.environment,
        jurisdiction: this.config.jurisdiction,
        locale: this.config.locale,
        sessionManager: this.dependencies['session-manager'],
        webLoginPreferences: this.dependencies['web-login-preferences'],
        onClose: onClose,
        onSubmit: onSubmit,
        onSubmitSuccess: onSubmitSuccess,
        onSubmitFailed: onSubmitFailed,
        onActionRequested: onActionRequested
      }), this.domNode);
    }
  }, {
    key: "changeState",
    value: function changeState(state) {
      if (this.state === state) {
        return;
      }

      this.state = state;

      if (this.onStateChangedCallback) {
        this.onStateChangedCallback({
          state: state
        });
      }
    }
  }]);

  return LoginFlow;
}(LoginFlowInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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